export const communicationsDashboardPageRootUrl = '/dashboard';

export const commsActivitySubPageUrl = `/comms-activity`;
export const commsActivityFeaturedConversationsSubPageUrl = `/comms-activity/featured-conversations`;
export const digitalSafetySubPageUrl = `/advanced-moderation`;
export const leadersAndAudiencesSubPageUrl = `/leaders-and-audiences`;
export const leadersActivityLogSugPageUrl = `/leaders-and-audiences/activity-log`;
export const conversationsSugPageUrl = `/conversations`;

export const communicationsDashboardPageUrl = `${communicationsDashboardPageRootUrl}${commsActivitySubPageUrl}`;
export const communicationsDashboardFeaturedConversationsUrl = `${communicationsDashboardPageRootUrl}${commsActivityFeaturedConversationsSubPageUrl}`;
export const communicationsDashboardDigitalSafetyPageUrl = `${communicationsDashboardPageRootUrl}${digitalSafetySubPageUrl}`;
export const communicationsDashboardLeadersAndAudiencesPageUrl = `${communicationsDashboardPageRootUrl}${leadersAndAudiencesSubPageUrl}`;
export const communicationsDashboardLeadersActivityLogPageUrl = `${communicationsDashboardPageRootUrl}${leadersActivityLogSugPageUrl}`;
export const communicationsDashboardConversationsPageUrl = `${communicationsDashboardPageRootUrl}${conversationsSugPageUrl}`;
